import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";

import withMobileDialog from "@material-ui/core/withMobileDialog";

import TransitTable from "./TransitTable.jsx";
import SearchPanel from "./SearchPanel.jsx";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import { connect } from "react-redux";
import { store } from "../../_store";
import { alertActions, commonActions } from "../../_actions";
import { commonService } from "../../_services";
import { appConstants } from "../../_constants";
import CircularProgress from "../../utils/CircularProgress";
import { EmptyRecord } from "../../utils/PageUtility";
import DownloadIcon from "@material-ui/icons/CloudDownload";
//import {SummaryCard} from "./SummaryCard";
import { appHelpers } from "../../_helpers/index.js";


const today = new Date();
let aMonthAgo = new Date();
aMonthAgo.setDate(today.getDate() - 30);

class Transit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedMonth: "",
            open: false,
            selectedMonthValue: "",
            selectedAirlineValue: "",
            selectedAirportValue: "",
            airlines: [],
            airports: [],
            AirlineId: "-1",
            currentPage: 1,
            pageSize: 10,
            totalCounts: 0,
            records: [],
            pageRequesting: true,
            From: 0,
            TotalPassengers: 0,
            flightNumbers: [],
            flightNumber: "-1",
            startDate: aMonthAgo,
            endDate: today,
            airportCode: "-1"
        };
    }

    componentDidMount() {
        let { airlines, airports, user } = store.getState();
        const { dispatch } = this.props;
        if (airlines) {
            this.setState({ airlines })
        } else {
            dispatch(commonActions.getAllAirlines());
        }
        if (airports) {
            this.setState({ airports })
        } else {
            dispatch(commonActions.getAllAirports());
        }
        if (user.AppRole === appConstants.ROLES.AIRLINE) {
            let userObj = {...user};
            let userAirline = {value: userObj.AirlineId, label: userObj.AirlineName};
            this.setState({ AirlineId: userAirline }, this.search);
        } else if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
            let userObj = {...user};
            let userLocation = {value: userObj.AirportCode, label: userObj.Location};
            this.setState({ airportCode: userLocation }, this.search);
        } else if(user.Location) {
            let userObj = {...user};
            let userLocation = {value: userObj.AirportCode, label: userObj.Location};
            this.setState({airportCode: userLocation}, this.search);
        }
        else {
            this.search();
        }

    }
    componentWillReceiveProps = function (nextProps) {
        const { airlines, airports } = nextProps;
        if (airlines) {
            let modifiedAirline = [...airlines];
            let allAirlines = {Airline: "All Airlines", AirlineId: "-1"};
            modifiedAirline.unshift(allAirlines);
            this.setState({ airlines: modifiedAirline });
        }
        if (airports) {
            let modifiedAirport = [...airports];
            modifiedAirport.unshift({Name: "All Airports", airportLocation: "-1"});
            this.setState({ airports: modifiedAirport });
        }
    };

    handleDateChange = (date, target) => {
        this.setState({ [target]: date });
    };


    handleSelect = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleReactSelectChange = (value, name) => {
        this.setState({ [name.name]: value });
        if (value.value === undefined || value.value === "-1" || value.value === "All Flights"){
            this.setState({[name.name]: "-1"} )
        }
        if (name.name === "AirlineId") {
            this.setState({ flightNumbers: [], FlightNumber: "-1" });
            this.fetchAirlineFlightNumbers(value.value);
        }
    };

    handleSelectChange = event => {
        this.setState({ [event.target.name]: event.target.value });
        this.fetchAirlineFlightNumbers(event.target.value);
    };

    handleSelectFlightNumber = event => {
        this.setState({ flightNumber: event.target.value });
    }


    //Get flight Numbers on select of airline by passing the airlineId
    fetchAirlineFlightNumbers = (airlineId) => {
        const { dispatch } = this.props;
        dispatch(alertActions.startRequest());
        commonService.getAirlinesFlightNumbers(airlineId)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    let modifiedFlights = [...response.Results];
                    modifiedFlights.unshift({FlightNumber: "All Flights"});
                    this.setState({ flightNumbers: modifiedFlights });
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                }
            });
    };


    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    //Displays Airport Name
    filterAirport = (airportCode) => {
        const { airports } = this.state;
        let result = airports.find(item => item.Code === airportCode);
        let name = result ? result.Name : "Unknown Airport"
        return name
    }

    downloadReport = (e, DownloadType) => {
        e.preventDefault();
        // const type = event.target.getAttribute('status')
        // console.warn(event.target,event.target.getAttribute)
        const { dispatch } = this.props;
        const { AirlineId, startDate, endDate, flightNumber, airportCode } = this.state;
        // let page = (pageNumber - 1)* pageSize;
        let Parameter = {
            StartDate: appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD"),
            EndDate: appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD"),
            DownloadType: DownloadType
        };

        if (airportCode !== "-1") {
            Parameter.AirportCode = airportCode.value;
        }
        if (AirlineId !== "-1") {
            Parameter.AirlineId = AirlineId.value;
        }
        if (flightNumber !== "-1") {
            Parameter.FlightNumber = flightNumber.value;
        }
        let payload = { Parameter };

        dispatch(alertActions.startRequest());
        commonService.downloadTransitPassenger(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    if (response.DownloadUrl) {
                        appHelpers.downloadFile(response.DownloadUrl, "Transit Passenger Report");
                    } else {
                        dispatch(alertActions.error(response.Message));
                    }
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ pageRequesting: false });
                }
            });
    };

    search = (pageNumber = 1) => {
        const { AirlineId, pageSize, startDate, endDate, flightNumber, airportCode } = this.state;
        const { dispatch } = this.props;
        let Parameter = {
            StartDate: appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD"),
            EndDate: appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD")
        };

        let from = (pageNumber - 1) * pageSize;

        let payload = {
            From: from,
            PageSize: pageSize,
        };
        if (airportCode !== "-1") {
            Parameter.AirportCode = airportCode.value;
        }
        if (AirlineId !== "-1") {
            Parameter.AirlineId = AirlineId.value;
        }
        if (flightNumber !== "-1" && flightNumber !== "All Flights") {
            Parameter.FlightNumber = flightNumber.value;
        }

        payload.Parameter = Parameter;

        dispatch(alertActions.startRequest());
        commonService.searchTransitPassenger(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                const response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    const { Results } = response;
                    this.setState({
                        currentPage: pageNumber,
                        pageRequesting: false,
                        records: Results,
                        totalCounts: response.TotalCount,
                    });
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ pageRequesting: false });
                }
            });
    };

    render() {
        const { classes, requesting, user } = this.props;
        const { AirlineId, airlines, airports,
            name, currentPage, pageSize, totalCounts, records,
            pageRequesting, startDate, endDate, flightNumbers, flightNumber,
            airportCode
        } = this.state;

        if (pageRequesting)
            return (
                <CircularProgress />
            );

        return (
            <div>
                <GridContainer>
                    <SearchPanel
                        user={this.props.user}
                        airports={airports}
                        airportCode={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location)? airportCode : airportCode.value}
                        airlines={airlines}
                        airline={name}
                        airport={airports}
                        selectChange={this.handleReactSelectChange}
                        handleDateChange={this.handleDateChange}
                        handleSelect={this.handleSelect}
                        AirlineId={(this.props.user.AppRole === appConstants.ROLES.AIRLINE ? AirlineId : AirlineId.value)}
                        startDate={startDate}
                        endDate={endDate}
                        onSearch={this.search}
                        handleSelectFlightNumber={this.handleSelectFlightNumber}
                        flightNumbers={flightNumbers}
                        flightNumber={flightNumber.value}
                    />
                </GridContainer>

                {/*<GridContainer>*/}
                {/*<GridItem xs={12} sm={12} md={12}>*/}
                {/*<SummaryCard*/}
                {/*classes={classes}*/}
                {/*passengerCount={TotalPassengers}*/}
                {/*billablePax={TotalBillablePassengers}*/}
                {/*outstandingPax={TotalOutstandingBillablePassengers}*/}
                {/*utilizedToken={TotalPscTokenUtilized}*/}
                {/*/>*/}

                {/*</GridItem>*/}
                {/*</GridContainer>*/}

                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="success">
                                <h4 className={classes.cardTitleWhite}>
                                    Transit Passenger Report
                </h4>
                                <p className={classes.cardCategoryWhite}>
                                    {`${totalCounts}`}
                                    {
                                        totalCounts === 1 &&
                                        ` record `
                                    }{
                                        totalCounts !== 1 &&
                                        ` records `
                                    }
                                    matched
                </p>
                            </CardHeader>
                            <CardBody>
                                {
                                    !pageRequesting && totalCounts !== 0
                                    &&
                                    <TransitTable
                                        fetchMore={this.search}
                                        pageSize={pageSize}
                                        records={records}
                                        currentPage={currentPage}
                                        totalCounts={totalCounts}
                                        filterAirport={this.filterAirport}
                                    />
                                }
                                {
                                    !pageRequesting && totalCounts === 0
                                    &&
                                    <EmptyRecord message={'No record found!'} />

                                }
                            </CardBody>
                            {
                                !pageRequesting && totalCounts !== 0 &&
                                <CardFooter chart style={{ justifyContent: "initial" }}>
                                    <Button type="button" status="1" color="info" onClick={(event) => this.downloadReport(event, appConstants.PDF_DOWNLOAD_TYPE, 'pdf')} disabled={requesting}>
                                        <DownloadIcon />
                                        Download PDF
                        </Button>
                                    <Button type="button" status="0" color="primary" onClick={(event) => this.downloadReport(event, appConstants.EXCEL_DOWNLOAD_TYPE, 'xls')} disabled={requesting}>
                                        <DownloadIcon />
                                        Download EXCEL
                        </Button>
                                </CardFooter>
                            }
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { alert, airlines, airports, user, requesting } = state;
    return {
        alert,
        airlines,
        airports,
        user,
        requesting
    };
}
export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(Transit)));



// WEBPACK FOOTER //
// ./src/views/Transit/Index.jsx